var map = {
	"./backend/Page": [
		321,
		0
	],
	"./electrolux-public/Page": [
		837,
		9
	],
	"./job-architecture/Page": [
		838,
		11
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 833;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/pages lazy ^\.\/.*\/Page$
// module id = 833
// module chunks = 22